import React from 'react'

const VERSION = '1.0.0'

export const Footer = () => {
  return (
    <footer className="footer">
      <span className="footer-version">v{VERSION}</span>
      <span className="footer-copy">© {new Date().getFullYear()} Gaurang Engineering. All rights reserved.</span>
    </footer>
  )
}
